import React from 'react';
import './FastFacts.css';

import Icon from '../../../components/Icon/Icon';

const fastFacts = ( props ) => (
	<section id="FastFacts">
		<h2>Quick Facts</h2>
		<p className="titleNote">
			Answers to the BURNING DESIRES OF YOUR HEART
		</p>
		<div className="facts">
			{
				props.facts.map( fact => (
					<div className="fact" key={ fact.id }>
						<Icon icon={ fact.icon } gradient="vertical" title={ fact.title } />
						<p className="fact-title">{ fact.title }</p>
						<div className="fact-content bg-gradient vertical" dangerouslySetInnerHTML={ {__html: fact.content } } />
					</div>
				))
			}
		</div>
	</section>
);

export default fastFacts;



// WEBPACK FOOTER //
// ./src/pages/Pay/FastFacts/FastFacts.js